import { IdsInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const diffuseOtoIndividualPropositionsToOl = (input: IdsInput) => {
  return restApiClient
    .url(constructApiUrl(API.enrollments.diffuseOtoIndividualPropositionsToOl.url, null))
    .post(input)
}
